<div class="create-survey-wrapper w-full  hidden sm:flex">
  <div class="form-wrapper w-full">
    <div class="py-0 px-0 sm:py-10 sm:px-8 w-full">
      <div class="general-information-content">
        General Information
      </div>
      <hr class="w-full separator">
      <div class="general-information-form-wrapper w-full flex flex-col items-center">
        <div class="general-information-input-section w-full sm:w-[90%]">
          <app-text-input
            (checkForErrors)="checkForErrors($event)"
            [error]="errorMessages['title']"
            [minLength]="3"
            [parentFormGroup]="createSurveyScheduleForm"
            controlName="title"
            label="Survey Name"
            placeholder="Survey Name"
            type="small"
          ></app-text-input>
        </div>
        <div class="general-information-description-input-section w-full sm:w-[90%]">
          <app-text-area-input
            (checkForErrors)="checkForErrors($event)"
            [error]="errorMessages['description']"
            [parentFormGroup]="createSurveyScheduleForm"
            controlName="description"
            label="Survey Description"
            placeholder="Survey Description"
            type="small"
          ></app-text-area-input>
        </div>
      </div>
    </div>
    <hr class="w-full separator">
    <div
      class="schedule-form-wrapper md:flex-row flex-col w-full flex md:justify-end justify-center">
      <div class="w-full md:w-[20%] flex justify-end">
        <app-primary-button
          (handleClick)="saveButtonClicked(false)"
          class="w-full "
          type="small">
          Save
        </app-primary-button>
      </div>
      <div
        class="w-full md:w-[20%] flex justify-end md:ml-[1rem] ml-0 md:my-0 my-[1rem]">
        <app-primary-button
          (handleClick)="saveButtonClicked(true)"
          class="w-full "
          type="small">
          Next
        </app-primary-button>
      </div>
    </div>
  </div>
</div>
<div class="flex sm:hidden">
  <app-screen-size-alert [hyperLinkText]="'Go Back To Manage Questionnaires'"
                         navigationLink="/stanford-admin/questionnaires/manage-questionnaires"></app-screen-size-alert>
</div>
